import { lazy, Suspense, type ComponentProps } from "react";

// Service/MOT booking must not download the separate tyre journey.
const TyreFlow = lazy(() =>
  import("../tyres/TyreFlow").then((module) => ({ default: module.TyreFlow })),
);

export function LazyTyreFlow(props: ComponentProps<typeof TyreFlow>) {
  return (
    <Suspense fallback={<p role="status">Loading tyres…</p>}>
      <TyreFlow {...props} />
    </Suspense>
  );
}
